import { HTMLAttributes } from "react"
import { styled, StyleProps, CSSFn, callCSSFn, CSS } from "../styles"
import { flexCss } from "../Flex"

export interface StyledContainerProps {
  variant?: `search` | `form`
  disabled?: boolean
  css?: CSSFn
}

export const makeInputStyle = (props: StyledContainerProps & StyleProps & { disabled?: boolean }): CSS => ({
  border: `1px solid`,
  borderColor: props.disabled ? props.theme.palette.grey.light : props.theme.palette.grey.dark,
  cursor: props.disabled ? `not-allowed` : `text`,
  borderRadius: `29px`,
  height: `2rem`,
  fontSize: `0.875rem`,
  backgroundColor: props.theme.palette.white,
  padding: props.variant === `search` ? `0 1.688rem 0 0.688rem` : `0 0.688rem`,
})

export const StyledContainer = styled.div<StyledContainerProps>((props: StyledContainerProps & StyleProps) => ({
  ...flexCss,
  width: `100%`,
  position: `relative`,
  alignItems: `center`,
  ...makeInputStyle(props),
  ...callCSSFn(props),
}))

StyledContainer.defaultProps = {
  variant: `form`,
  css: undefined,
}

export const StyledInput = styled.input<HTMLAttributes<HTMLInputElement>>(
  (props: StyleProps & { disabled?: boolean }) => ({
    background: `unset`,
    border: `none`,
    outline: `none`,
    width: `100%`,
    height: `100%`,
    color: props.theme.palette.coal.dark,
    cursor: props.disabled ? `not-allowed` : `text`,
    fontWeight: props.theme.fonts.body.fontWeight,
  })
)

export const SearchIconWrap = styled.button<HTMLAttributes<HTMLSpanElement>>(
  (props: StyleProps & { disabled?: boolean }) => ({
    borderRadius: `50%`,
    borderWidth: `0px`,
    cursor: props.disabled ? `not-allowed` : `pointer`,
    background: props.disabled ? props.theme.palette.grey.dark : props.theme.palette.coal.dark,
    height: `2rem`,
    display: `flex`,
    flex: `0 0 2rem`,
    alignItems: `center`,
    justifyContent: `center`,
    marginLeft: `10px`,
  })
)
